import { Link } from 'react-router-dom'
import { cn } from '~/shadcn/lib/utils'
import { LogoDarkIcon } from '../icons/LogoDarkIcon'
import { LogoLightIcon } from '../icons/LogoLightIcon'
import { useIsDesktop } from '../layout/useIsDesktop'
import { PageContainer } from '../page-container/PageContainer'

type Props = {
  colorScheme: 'light' | 'dark'
  homeLinkPath: string
  children: React.ReactNode | React.ReactNode[]
}

function TopNavigation({ colorScheme, homeLinkPath, children }: Props) {
  const isDark = colorScheme === 'dark'
  const isDesktop = useIsDesktop()

  return (
    <PageContainer
      className={cn(
        'flex flex-row w-full justify-between items-center border-b border-b-border px-5 md:px-8 h-23 md:h-25 z-40',
        !isDesktop ? 'sticky top-0' : '',
        isDark
          ? 'bg-foreground text-background'
          : 'bg-background text-foreground'
      )}>
      <Link to={homeLinkPath} className="flex items-center">
        {isDark ? (
          <LogoLightIcon isMobile={!isDesktop} />
        ) : (
          <LogoDarkIcon isMobile={!isDesktop} />
        )}
      </Link>
      {children}
    </PageContainer>
  )
}

export { TopNavigation }
